const MAX_INTEGER_TONNES = 99;
const MAX_DECIMAL_CENT = 99;

export function buildIntegerTonnesOptions() {
  return Array.from({ length: MAX_INTEGER_TONNES + 1 }, (_, index) => index);
}

export function buildDecimalCentOptions() {
  return Array.from({ length: MAX_DECIMAL_CENT + 1 }, (_, index) => index);
}

export function formatDecimalCentLabel(decimalPart) {
  return String(decimalPart).padStart(2, "0");
}

export function formatWeightFromWheelParts(integerPart, decimalPart) {
  if (integerPart === 0 && decimalPart === 0) {
    return "";
  }
  return `${integerPart}.${formatDecimalCentLabel(decimalPart)}`;
}

export function parseWeightToWheelParts(weightInput) {
  const normalized = String(weightInput ?? "")
    .trim()
    .replace(",", ".");
  if (!normalized || !/^[0-9]+([.][0-9]{0,2})?$/.test(normalized)) {
    return { integerPart: 0, decimalPart: 0 };
  }

  const [integerRaw, decimalRaw = ""] = normalized.split(".");
  const integerPart = Math.min(
    MAX_INTEGER_TONNES,
    Math.max(0, parseInt(integerRaw, 10) || 0),
  );
  const paddedDecimal = `${decimalRaw}00`.slice(0, 2);
  const decimalPart = Math.min(
    MAX_DECIMAL_CENT,
    Math.max(0, parseInt(paddedDecimal, 10) || 0),
  );

  return { integerPart, decimalPart };
}
